import { SimpleLayout } from '@/components/Layout';
import { ReactNode } from 'react';

interface SetupLayoutProps {
  children: ReactNode;
}

export const SetupLayout = ({ children }: SetupLayoutProps) => {
  return (
    <SimpleLayout>
      <div className="flex items-center justify-center p-3 pt-10">
        <div className="w-full max-w-lg rounded-3xl bg-white p-6 drop-shadow lg:p-8">
          {children}
        </div>
      </div>
    </SimpleLayout>
  );
};
